import { Lang } from '../../Lang';
import { FormGroup2, Input2, InputType2, LangTextV2, ModalDialog2, ModalDialogType2, Switch2, Textarea2 } from 'bambooo';
/**
 * Edit modal for one `encounter_categories` row.
 *
 * Exposes the soft-delete switch so admins can revive a previously
 * deleted row directly here — separating the kill-switch into a
 * dedicated endpoint would create the same UX-asymmetry we already
 * had on Vehicle.
 */
export class EncounterCategoriesEditModal extends ModalDialog2 {
    constructor() {
        super({ modalType: ModalDialogType2.large });
        this._id = null;
        const body = jQuery('<div class="card-body"/>').appendTo(this.getBody());
        const groupName = new FormGroup2({ label: new LangTextV2({ text: 'Name' }) });
        groupName.appendTo(body);
        this._inputName = new Input2({ type: InputType2.text });
        this._inputName.appendTo(groupName);
        const groupDescription = new FormGroup2({ label: new LangTextV2({ text: 'Description' }) });
        groupDescription.appendTo(body);
        this._textareaDescription = new Textarea2({});
        this._textareaDescription.appendTo(groupDescription);
        const groupDeleted = new FormGroup2({ label: new LangTextV2({ text: 'Deleted' }) });
        groupDeleted.appendTo(body);
        this._switchDeleted = new Switch2({});
        this._switchDeleted.appendTo(groupDeleted);
        this.addButtonClose(Lang.i().l('Close'));
        this.addButtonSave(Lang.i().l('Save'), true);
    }
    getEntryId() {
        return this._id;
    }
    setEntryId(id) {
        this._id = id;
    }
    resetValues() {
        this._id = null;
        this._inputName.setValue('');
        this._textareaDescription.setValue('');
        this._switchDeleted.setEnable(false);
    }
    getName() {
        return this._inputName.getValue().trim();
    }
    setName(name) {
        this._inputName.setValue(name);
    }
    getDescription() {
        return this._textareaDescription.getValue();
    }
    setDescription(description) {
        this._textareaDescription.setValue(description);
    }
    getIsDeleted() {
        return this._switchDeleted.isEnable();
    }
    setIsDeleted(deleted) {
        this._switchDeleted.setEnable(deleted);
    }
}
